// Income  Mutations

export const updateIncomeList = (state, payload) => {
  state.incomeList = payload
}

export const fetchIncomeInfo = (state, payload) => {
  state.incomeInfo = payload
}
